import { Box, styled, Typography } from "@mui/material";

export const TextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "clamp(0.4vh, 1.5vh, 2vh) !important",
  textAlign: "center",
  padding: "clamp(0.5rem, 2vw, 1rem)",
  maxWidth: "min(90%, 750px)",
  width: "100%",
}));

export const TitleText = styled(Typography)({
  fontWeight: "700",
  fontSize: "clamp(1.4rem, 2vw + 1rem, 2.6rem)",
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
  color: "#FFF",
  background:
    "linear-gradient(92.49deg, #316feb -5.99%, #4fadc7 56.53%, #6feea6 90.16%) !important",
  "-webkit-background-clip": "text !important",
  "-webkit-text-fill-color": "transparent !important",
  backgroundClip: "text !important",
  display: "inline-block !important",
  letterSpacing: "0 !important",
});


export const BetaText = styled('span')({
  fontWeight: 700,
  fontSize: 'clamp(0.7rem, 0.8vw + 0.4rem, 1rem)',
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: '#70F0A3',
  marginLeft: 'clamp(4px, 0.5vw, 8px)',
  verticalAlign: 'text-bottom',
  display: 'inline-block',
});


export const SubTitle = styled(Typography)({
  marginTop: "1.5vh !important",
  fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important",
  fontSize: "clamp(0.7rem, 0.6vw + 0.6rem, 1rem)",
  fontWeight: "400",
  color: "#FFF !important",
  textAlign: "center",
  lineHeight: "150%",

  '& .lineBreak': {
    display: 'inline',
    '@media (min-width: 1024px)': { // adjust breakpoint for desktop
      display: 'block',
    },
  },
  "@media (max-width: 480px)": {
    fontSize: "0.7rem",
  },
});

export const HeaderBoxNew = styled(Box)(({ theme }) => ({
    width: "100%",
    position: "relative",      // keep relative
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }));
